(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const dialog = document.querySelector('[data-cart-drawer]');
  if (!dialog) return;
  const SECTION = dialog.dataset.section || 'cart-drawer';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const status = document.querySelector('[data-cart-status]');
  const i18nEl = document.querySelector('[data-cart-i18n]');
  const i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {};
  const live = () => dialog.querySelector('[data-cart-drawer-live]');
  let busy = false;

  const announce = (msg) => {
    if (!status || !msg) return;
    status.textContent = '';
    setTimeout(() => { status.textContent = msg; }, 60);
  };
  const titleText = () => (dialog.querySelector('[data-cart-drawer-title]')?.textContent || '').replace(/\s+/g, ' ').trim();
  const broadcast = () => {
    const el = live();
    const n = el ? Number(el.dataset.itemCount || 0) : 0;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: n } }));
    return n;
  };
  const swap = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-live]');
    const current = live();
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    current.dataset.itemCount = fresh.dataset.itemCount || '0';
  };
  const refresh = async () => {
    const res = await fetch(`${root}?sections=${SECTION}`, { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const json = await res.json();
    if (json[SECTION]) swap(json[SECTION]);
  };
  const open = () => {
    const api = window.GarnioDialog;
    if (api) api.open(dialog, dialog.querySelector('[data-cart-drawer-title]'));
    else if (!dialog.open) dialog.showModal();
  };
  const setBusy = (on) => {
    busy = on;
    live()?.setAttribute('aria-busy', String(on));
    dialog.classList.toggle('is-busy', on);
  };
  const showError = (msg) => {
    const box = dialog.querySelector('[data-cart-error]');
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
  };
  const focusIn = (selector) => {
    const target = selector ? dialog.querySelector(selector) : null;
    (target || dialog.querySelector('[data-cart-drawer-title]'))?.focus({ preventScroll: true });
  };

  async function change(key, quantity, focusSelector) {
    if (busy) return;
    setBusy(true);
    showError('');
    try {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: SECTION, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || i18n.error);
      if (data.sections && data.sections[SECTION]) swap(data.sections[SECTION]); else await refresh();
      broadcast();
      announce(`${i18n.updated || ''} ${titleText()}`);
      focusIn(focusSelector);
    } catch (err) {
      showError(err.message || i18n.error);
      await refresh().catch(() => {});
      broadcast();
    } finally {
      setBusy(false);
    }
  }

  dialog.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change], [data-qty-remove]');
    if (!btn) return;
    const key = btn.dataset.key;
    if (btn.hasAttribute('data-qty-remove')) { change(key, 0); return; }
    const input = dialog.querySelector(`[data-qty-input][data-key="${key}"]`);
    const next = Math.max(0, (parseInt(input && input.value, 10) || 0) + Number(btn.dataset.qtyChange));
    change(key, next, `[data-qty-change="${btn.dataset.qtyChange}"][data-key="${key}"]`);
  });
  dialog.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const q = Math.max(0, parseInt(input.value, 10) || 0);
    change(input.dataset.key, q, `[data-qty-input][data-key="${input.dataset.key}"]`);
  });
  document.addEventListener('cart:item-added', (e) => {
    const d = e.detail || {};
    showError('');
    const apply = d.sections && d.sections[SECTION] ? Promise.resolve(swap(d.sections[SECTION])) : refresh().catch(() => {});
    apply.then(() => { broadcast(); open(); announce(`${i18n.added || ''} ${titleText()}`); });
  });
  document.addEventListener('cart:open', open);
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    refresh().catch(() => {});
    open();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
/**
 * CartForm - Handles quantity updates and cart totals
 */
class CartForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.cart__form');
    this.subtotalEl = this.querySelector('[data-cart-subtotal]');
  }

  connectedCallback() {
    if (!this.form) return;
    this.form.addEventListener('click', this.onButtonClick.bind(this));
    this.form.addEventListener('change', this.onInputChange.bind(this));
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  updateTotals(cart) {
    if (this.subtotalEl) {
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    }

    cart.items.forEach((item) => {
      const row = this.querySelector(`[data-key="${item.key}"]`);
      if (!row) return;

      const qtyInput = row.querySelector('[data-qty-input]');
      if (qtyInput) qtyInput.value = item.quantity;

      const linePrice = row.querySelector('[data-line-price]');
      if (linePrice) linePrice.textContent = this.formatMoney(item.line_price);
    });

    // Dispatch event for header cart badge
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));

    // Reload if cart is empty
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  async changeQuantity(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      if (!response.ok) throw new Error('Cart update failed');

      const cart = await response.json();
      this.updateTotals(cart);
    } catch (error) {
      console.error('Failed to update cart:', error);
      window.location.reload();
    }
  }

  onButtonClick(event) {
    const btn = event.target.closest('.qty-btn');
    if (!btn) return;

    const row = btn.closest('[data-key]');
    const input = row?.querySelector('[data-qty-input]');
    if (!row || !input) return;

    const key = row.dataset.key;
    let next = parseInt(input.value || '0', 10);

    if (btn.dataset.action === 'increment') next += 1;
    if (btn.dataset.action === 'decrement') next = Math.max(0, next - 1);

    input.value = next;
    this.changeQuantity(key, next);
  }

  onInputChange(event) {
    const input = event.target.closest('[data-qty-input]');
    if (!input) return;

    const row = input.closest('[data-key]');
    if (!row) return;

    const key = row.dataset.key;
    const next = Math.max(0, parseInt(input.value || '0', 10));
    input.value = next;
    this.changeQuantity(key, next);
  }
}

if (!customElements.get('cart-form')) {
  customElements.define('cart-form', CartForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(() => {
  const api = () => window.GarnioDialog;
  document.querySelectorAll('[data-filters-open]').forEach((b) => b.addEventListener('click', () => {
    const d = document.getElementById(b.getAttribute('aria-controls'));
    if (d && api()) api().open(d, d.querySelector('[data-autofocus]'));
  }));
  document.querySelectorAll('[data-sort-select]').forEach((s) => s.addEventListener('change', () => s.form && s.form.requestSubmit()));
  // keep URLs clean: empty price fields are not submitted
  document.querySelectorAll('[data-filter-form]').forEach((f) => f.addEventListener('submit', () => f.querySelectorAll('input[type="number"]').forEach((i) => { if (!i.value) i.disabled = true; })));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const slowMs = () => (reduceMotion.matches ? 0 : 320);
  const fastMs = () => (reduceMotion.matches ? 0 : 200);

  /* ---- <dialog> helpers shared with the cart drawer (window.GarnioDialog) ---- */
  function openDialog(dialog, focusTarget) {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    requestAnimationFrame(() => dialog.classList.add('is-open'));
    const target = focusTarget || dialog.querySelector('[data-autofocus]') || dialog.querySelector('[data-dialog-close]');
    if (target) setTimeout(() => target.focus({ preventScroll: true }), 40);
    dialog.dispatchEvent(new CustomEvent('dialog:open'));
  }
  function closeDialog(dialog) {
    if (!dialog || !dialog.open || dialog.dataset.closing) return;
    dialog.dataset.closing = '1';
    dialog.classList.remove('is-open');
    setTimeout(() => { dialog.close(); delete dialog.dataset.closing; }, slowMs());
  }
  document.querySelectorAll('dialog[data-drawer]').forEach((dialog) => {
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-dialog-close]')) closeDialog(dialog);
    });
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); closeDialog(dialog); });
  });
  window.GarnioDialog = { open: openDialog, close: closeDialog };

  /* ---- Mobile navigation drawer + accordions ---- */
  const navDrawer = document.querySelector('[data-nav-drawer]');
  header.querySelectorAll('[data-nav-open]').forEach((btn) => btn.addEventListener('click', () => openDialog(navDrawer)));
  navDrawer?.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-acc-toggle]');
    if (!toggle) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (panel) panel.hidden = expanded;
  });

  /* ---- Search dialog + predictive search (official Predictive Search API, section rendering) ---- */
  const searchDialog = document.querySelector('[data-search-dialog]');
  const searchInput = searchDialog?.querySelector('[data-search-input]');
  const searchResults = searchDialog?.querySelector('[data-search-results]');
  const searchStatus = searchDialog?.querySelector('[data-search-status]');
  header.querySelectorAll('[data-search-open]').forEach((btn) => btn.addEventListener('click', () => openDialog(searchDialog, searchInput)));
  if (searchDialog && searchInput && searchResults) {
    const endpoint = searchDialog.dataset.searchUrl || '/search/suggest';
    const sectionId = searchDialog.dataset.searchSection || 'predictive-search';
    let controller = null;
    let timer = null;
    let lastQuery = '';
    const setStatus = (msg) => { if (searchStatus) searchStatus.textContent = msg || ''; };
    const clearResults = () => {
      searchResults.innerHTML = '';
      searchResults.hidden = true;
      setStatus('');
      lastQuery = '';
    };
    async function runSearch(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      searchResults.setAttribute('aria-busy', 'true');
      try {
        const params = new URLSearchParams({
          q,
          section_id: sectionId,
          'resources[type]': 'product,collection,page,article,query',
          'resources[limit]': '4',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'hide'
        });
        const res = await fetch(`${endpoint}?${params.toString()}`, { signal: controller.signal });
        if (!res.ok) throw new Error(String(res.status));
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-predictive-results]');
        searchResults.innerHTML = fresh ? fresh.innerHTML : '';
        searchResults.hidden = !fresh;
        setStatus(fresh ? fresh.dataset.status : '');
      } catch (err) {
        if (err.name !== 'AbortError') clearResults();
      } finally {
        searchResults.setAttribute('aria-busy', 'false');
      }
    }
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { clearResults(); return; }
      if (q === lastQuery) return;
      timer = setTimeout(() => { lastQuery = q; runSearch(q); }, 250);
    });
    searchDialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeDialog(searchDialog); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const links = [...searchResults.querySelectorAll('a, button')].filter((el) => el.offsetParent !== null);
      if (!links.length) return;
      const i = links.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (i < links.length - 1 ? links[i + 1] : links[0]).focus();
      else if (i <= 0) searchInput.focus();
      else links[i - 1].focus();
    });
    searchDialog.addEventListener('dialog:open', () => searchInput.select());
  }

  /* ---- Desktop disclosure navigation ---- */
  const items = [...header.querySelectorAll('[data-nav-item]')];
  const btnOf = (item) => item.querySelector('[data-nav-toggle]');
  const panelOf = (item) => item.querySelector('[data-nav-panel]');
  const isOpen = (item) => btnOf(item).getAttribute('aria-expanded') === 'true';
  let hoverTimer = null;
  function setOpen(item, open) {
    if (open === isOpen(item)) return;
    const btn = btnOf(item);
    const panel = panelOf(item);
    btn.setAttribute('aria-expanded', String(open));
    item.classList.toggle('is-open', open);
    if (open) {
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.add('is-open'));
    } else {
      panel.classList.remove('is-open');
      setTimeout(() => { if (!isOpen(item)) panel.hidden = true; }, fastMs());
    }
    header.classList.toggle('has-open-panel', items.some(isOpen));
  }
  const closeOthers = (item) => items.forEach((other) => { if (other !== item) setOpen(other, false); });
  items.forEach((item) => {
    const btn = btnOf(item);
    const panel = panelOf(item);
    if (!btn || !panel) return;
    btn.addEventListener('click', () => { const next = !isOpen(item); closeOthers(item); setOpen(item, next); });
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); closeOthers(item); setOpen(item, true); panel.querySelector('a, button')?.focus(); }
    });
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen(item)) { e.preventDefault(); e.stopPropagation(); setOpen(item, false); btn.focus(); }
    });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) setOpen(item, false); });
    item.addEventListener('pointerenter', (e) => {
      if (!finePointer.matches || e.pointerType === 'touch') return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => { closeOthers(item); setOpen(item, true); }, 120);
    });
    item.addEventListener('pointerleave', (e) => {
      if (!finePointer.matches || e.pointerType === 'touch') return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => setOpen(item, false), 220);
    });
  });
  document.addEventListener('pointerdown', (e) => {
    items.forEach((item) => { if (isOpen(item) && !item.contains(e.target)) setOpen(item, false); });
  });

  /* ---- Cart badge (count comes from cart:updated events: drawer, cart page, product form) ---- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = String(n); el.hidden = n === 0; });
    document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
      const tpl = n === 0 ? el.dataset.zero : n === 1 ? el.dataset.one : (el.dataset.other || '').replace('__count__', String(n));
      el.textContent = tpl || String(n);
    });
  }
  document.addEventListener('cart:updated', async (e) => {
    const d = e.detail || {};
    if (typeof d.item_count === 'number') { setCount(d.item_count); return; }
    if (d.cart && typeof d.cart.item_count === 'number') { setCount(d.cart.item_count); return; }
    try { const cart = await (await fetch('/cart.js')).json(); setCount(cart.item_count); } catch (err) { /* keep current badge */ }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) { /* recommendations are optional */ }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(() => {
  const section = document.querySelector('.pdp');
  if (!section) return;
  const api = () => window.GarnioDialog;
  // sticky bar
  const bar = section.querySelector('[data-sticky-bar]');
  const addBtn = section.querySelector('[data-add-to-cart]');
  const price = section.querySelector('[data-product-price]');
  const stickyPrice = section.querySelector('[data-sticky-price]');
  const stickyAdd = section.querySelector('[data-sticky-add]');
  if (bar && addBtn) {
    bar.hidden = false;
    let ticking = false;
    const update = () => { ticking = false; bar.classList.toggle('is-visible', addBtn.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    stickyAdd && stickyAdd.addEventListener('click', () => { if (!addBtn.disabled) addBtn.closest('form').requestSubmit(); });
    if (price && stickyPrice) new MutationObserver(() => { stickyPrice.textContent = price.textContent; stickyAdd && (stickyAdd.disabled = addBtn.disabled); }).observe(price, { childList: true, characterData: true, subtree: true });
    new MutationObserver(() => { stickyAdd && (stickyAdd.disabled = addBtn.disabled); }).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
  // upload funnel (blank products): three file fields (Vorderseite, Rückseite, Mockup), per-file type/size
  // checks, back-side field follows the Druck option, rules: front file OR text/notes; Beidseitig additionally
  // back file OR notes (handoff-5 §3). Property names are read by the app's orders/create webhook.
  const uf = section.querySelector('[data-upload-form]');
  if (uf) {
    const fieldOf = (kind) => uf.querySelector(`[data-upload-field="${kind}"]`);
    const inputOf = (kind) => fieldOf(kind)?.querySelector('[data-upload-input]');
    const text = uf.querySelector('[data-upload-text]'); const notes = uf.querySelector('[data-upload-notes]');
    const errFront = uf.querySelector('[data-upload-error]'); const errBack = uf.querySelector('[data-upload-error-back]');
    const hideErrors = () => { if (errFront) errFront.hidden = true; if (errBack) errBack.hidden = true; };
    uf.querySelectorAll('[data-upload-input]').forEach((input) => {
      const name = input.closest('[data-upload-field]').querySelector('[data-file-name]');
      const reset = () => { input.value = ''; name.textContent = name.dataset.empty || ''; };
      input.addEventListener('change', () => {
        const f = input.files && input.files[0]; if (!f) { name.textContent = name.dataset.empty || ''; return; }
        const ok = /^(image\/(png|jpeg|svg\+xml)|application\/pdf)$/.test(f.type);
        if (!ok) { alert(input.dataset.errorType); reset(); return; }
        if (f.size > (parseInt(input.dataset.maxMb, 10) || 20) * 1024 * 1024) { alert(input.dataset.errorSize); reset(); return; }
        name.textContent = f.name; hideErrors();
      });
    });
    text?.addEventListener('input', hideErrors); notes?.addEventListener('input', hideErrors);
    // Druck = Beidseitig → back-side field visible + enabled; otherwise hidden + disabled (not submitted)
    const druckPos = uf.querySelector('.pdp__upload')?.dataset.druckPosition || '0';
    const isDouble = () => druckPos !== '0' && (uf.querySelector(`input[name="option${druckPos}"]:checked`)?.value === 'Beidseitig');
    const syncBack = () => {
      const field = fieldOf('back'); const input = inputOf('back'); if (!field || !input) return;
      const on = isDouble(); field.hidden = !on; input.disabled = !on; if (!on && errBack) errBack.hidden = true;
    };
    // bubbling change: product-form.js (listening on the form) has already re-checked the radios
    uf.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) syncBack(); });
    syncBack();
    const hasFile = (kind) => { const i = inputOf(kind); return !!(i && !i.disabled && i.files && i.files.length > 0); };
    uf.querySelector('form')?.addEventListener('submit', (e) => {
      const hasNotes = (notes?.value || '').trim().length > 0;
      const hasText = (text?.value || '').trim().length > 0 || hasNotes;
      let fail = null;
      if (!hasFile('front') && !hasText) fail = { err: errFront, kind: 'front' };
      else if (isDouble() && !hasFile('back') && !hasNotes) fail = { err: errBack, kind: 'back' };
      if (!fail) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (fail.err) fail.err.hidden = false;
      const field = fieldOf(fail.kind);
      field?.querySelector('.pdp__file-btn')?.scrollIntoView({ block: 'center' });
      field?.querySelector('[data-upload-input]')?.focus({ preventScroll: true });
    }, true);
  }
  // selected value next to the legend
  section.querySelectorAll('.pdp__option').forEach((fs) => fs.addEventListener('change', (e) => {
    const label = e.target.closest('label');
    const out = fs.querySelector('.pdp__legend-value');
    if (label && out) out.textContent = label.querySelector('span:last-child')?.textContent.trim() || e.target.value;
  }));
  // lightbox
  const lb = document.querySelector('[data-lightbox]');
  const main = section.querySelector('[data-main-image]');
  section.querySelector('[data-lightbox-open]')?.addEventListener('click', () => {
    if (!lb || !main || !api()) return;
    const img = lb.querySelector('[data-lightbox-img]');
    img.src = (main.currentSrc || main.src).replace(/width=\d+/, 'width=1600');
    img.alt = main.alt;
    api().open(lb, lb.querySelector('[data-dialog-close]'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
